// extracted by mini-css-extract-plugin
export default {"description":"Description_description__TssBA","description-title":"Description_description-title__2DPz0","description-text":"Description_description-text__edLTS"};